if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;

        this.submitButton = this.querySelector('[type="submit"]');
        if (!this.submitButton) return;

        this.submitButtonText = this.submitButton.querySelector('span');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.hideErrors = this.dataset.hideErrors === 'true';
        this.error = false;

        const variantInput = this.variantIdInput;
        if (variantInput) {
          variantInput.disabled = false;
        }

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (!this.submitButton) return;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.error = false;

        const originalButtonText = this.submitButtonText ? this.submitButtonText.textContent : '';

        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');

        if (this.submitButtonText) {
          this.submitButtonText.textContent = 'Adding...';
        }

        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        config.body = formData;

        fetch('/cart/add.js', config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              if (
                typeof publish !== 'undefined' &&
                typeof PUB_SUB_EVENTS !== 'undefined' &&
                PUB_SUB_EVENTS.cartError
              ) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
              }

              this.handleErrorMessage(response.description || response.message || 'Unable to add item.');

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (soldOutMessage && this.submitButtonText) {
                this.submitButton.setAttribute('aria-disabled', 'true');
                this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
              }

              this.error = true;
              return;
            }

            if (this.submitButtonText) {
              this.submitButtonText.textContent = 'Added';
            }

            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
            document.dispatchEvent(new CustomEvent('cart:updated'));

            const opened = await this.openCartFast();

            if (!opened) {
              window.location.href = '/cart';
              return;
            }

            setTimeout(() => {
              if (this.submitButtonText) {
                this.submitButtonText.textContent = originalButtonText || 'Add to cart';
              }
              this.submitButton.removeAttribute('aria-disabled');
              this.submitButton.classList.remove('loading');
              if (spinner) spinner.classList.add('hidden');
            }, 500);
          })
          .catch((e) => {
            console.error('Add to cart error:', e);
            this.error = true;
            this.handleErrorMessage('Something went wrong. Please try again.');

            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            if (this.submitButtonText) {
              this.submitButtonText.textContent = originalButtonText || 'Add to cart';
            }
            if (spinner) spinner.classList.add('hidden');
          })
          .finally(() => {
            if (
              typeof CartPerformance !== 'undefined' &&
              CartPerformance &&
              typeof CartPerformance.measureFromEvent === 'function'
            ) {
              CartPerformance.measureFromEvent('add:user-action', evt);
            }
          });
      }

      async openCartFast() {
  const drawer = document.querySelector('cart-drawer');

  if (drawer) {
    try {
      const res = await fetch('/cart?section_id=cart-drawer');
      const text = await res.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      const newDrawer = html.querySelector('cart-drawer');

      if (newDrawer) {
        // Replace FULL drawer content
        drawer.innerHTML = newDrawer.innerHTML;

        // Sync ALL classes (critical fix)
        drawer.className = newDrawer.className;

        // Safety fallback
        drawer.classList.remove('is-empty');
      }

      // Use native Dawn drawer open if available
      if (typeof drawer.open === 'function') {
        drawer.open();
        return true;
      }

      // Fallback open (if open() somehow fails)
      drawer.classList.add('active', 'animate');
      drawer.setAttribute('open', 'true');
      document.body.classList.add('overflow-hidden');

      return true;
    } catch (e) {
      console.error('Drawer refresh failed:', e);
    }
  }

  // Fallback to cart notification if drawer not found
  const cartNotification = document.querySelector('cart-notification');
  if (cartNotification) {
    try {
      if (typeof cartNotification.open === 'function') {
        cartNotification.open();
        return true;
      }
      cartNotification.classList.add('active', 'is-open');
      return true;
    } catch (e) {
      console.error('Cart notification failed:', e);
    }
  }

  // Last fallback: trigger cart icon click
  const trigger = document.querySelector('[data-cart-toggle], .header__icon--cart');
  if (trigger) {
    trigger.click();
    return true;
  }

  return false;
}
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) {
            this.submitButtonText.textContent = text;
          }
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText && window.variantStrings) {
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        if (!this.form) return null;
        return this.form.querySelector('[name="id"]');
      }
    }
  );
}